import { render, staticRenderFns } from "./KnInventory.vue?vue&type=template&id=e5b1ade4&"
import script from "./KnInventory.vue?vue&type=script&lang=js&"
export * from "./KnInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports